import * as XLSX from 'xlsx';
import { ReportKey, sampleHeaders } from './reportColumnConfig';

export function downloadSampleFile(report: ReportKey, customHeaders: string[]) {
    const headers = sampleHeaders(report, customHeaders);
    const sheet = XLSX.utils.aoa_to_sheet([headers]);
    sheet['!cols'] = headers.map((header) => ({ wch: Math.max(header.length + 2, 16) }));
    const book = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(book, sheet, 'Sample');
    XLSX.writeFile(book, `${report}-sample.xlsx`);
}
